export const aggregateCounts = (responses) => {
  const counts = {};

  responses.forEach((response) => {
    const questionIds = new Set();
    const questionId = response.question_title;

    response.themes.forEach((theme) => {
      const themeId = theme.theme;
      const override = theme.question_override;

      if (override) {
        questionIds.add(override);
      } else {
        questionIds.add(questionId);
      }

      const usedQuestion = override || questionId;

      if (!counts[usedQuestion]) {
        counts[usedQuestion] = { count: 0, themes: {} };
      }

      if (!counts[usedQuestion].themes[themeId]) {
        counts[usedQuestion].themes[themeId] = {
          count: 0,
          exemplar: 0,
          prevalence: 0,
          superExemplar: 0,
        };
      }

      counts[usedQuestion].themes[themeId].count++;
      if (theme.exemplar) {
        counts[usedQuestion].themes[themeId].exemplar++;
      }
      if (theme.super_exemplar) {
        counts[usedQuestion].themes[themeId].superExemplar++;
      }
    });

    Array.from(questionIds).forEach((questionId) => {
      counts[questionId].count++;
    });
  });

  Object.keys(counts).forEach((questionId) => {
    const question = counts[questionId];
    Object.keys(question.themes).forEach((themeId) => {
      const theme = question.themes[themeId];
      theme.prevalence = Math.floor((100 * theme.count) / question.count);
    });
  });

  return counts;
};

export const exemplarAggregateCounts = (responses) => {
  const counts = {};

  responses.forEach((response) => {
    if (!response.exemplar) {
      return;
    }

    const questionId = response.question;

    if (!counts[questionId]) {
      counts[questionId] = { count: 0, themes: {} };
    }

    counts[questionId].count++;

    const themeId = response.theme;

    if (!counts[questionId].themes[themeId]) {
      counts[questionId].themes[themeId] = {
        count: 0,
        superExemplar: 0,
        prevalence: 0,
      };
    }

    counts[questionId].themes[themeId].count++;
    if (response.super_exemplar) {
      counts[questionId].themes[themeId].superExemplar++;
    }
  });

  Object.keys(counts).forEach((questionId) => {
    const question = counts[questionId];
    Object.keys(question.themes).forEach((themeId) => {
      const theme = question.themes[themeId];
      theme.prevalence = Math.floor((100 * theme.count) / question.count);
    });
  });

  return counts;
};

export const tabulizeData = (counts, selectedQuestion, themesShorthands) => {
  return Object.entries(counts[selectedQuestion]?.themes || []).map(([theme, data]) => ({
    ...data,
    id: `${selectedQuestion}---${theme}`,
    theme: themesShorthands[parseInt(theme)],
    themeId: theme,
  }));
};

const localeNames = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  hr: 'Hrvatski',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  pt: 'Português',
  uk: 'Українська',
};

export const tabulizeResponseData = (responses, themesShorthands, selectedTheme) => {
  return responses.flatMap((response) => {
    return response.themes
      .filter((theme) => {
        const themeId = theme.theme;
        return themeId === selectedTheme || selectedTheme === 'all';
      })
      .map((theme) => {
        const themeId = theme.theme;
        if (themeId !== selectedTheme && selectedTheme !== 'all') {
          return null;
        }

        return {
          id: `${response.question_title}---${response.id}---${themeId}`,
          theme: themesShorthands[parseInt(themeId)],
          theme_id: themeId,
          english_response_value: response.english_response_value,
          original_response_value: response.original_response_value,
          exemplar: theme.exemplar,
          super_exemplar: !!theme.super_exemplar,
          other_themes: response.themes.filter((t) => t.theme !== themeId),
          responseId: response.id,
          themes: response.themes,
          question: response.question_title,
          school: response.participant.school,
          response_language: localeNames[response.response_language],
        };
      });
  });
};
